<template>
  <div>
    <MasterLayout>
      <div style="text-align: center">
        <div class="quickfuel_first_row banner_height section__row">
          <div
            class="quickfuel_first_row_right_section"
            style="border-radius: 12px; flex: 0 0 100%"
            :style="[
              {
                backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
              }
            ]"
          >
            <div class="row align-items-center quick_fuel hundered_percent_height" >
              <div class="text-center col-md-6 col-lg-6">
                 <img
                    src="@/assets/img/back_arrow.png"
                    @click="changeRoute('vehicle')"
                    width="40"
                  />
                
              </div>
              <div class="text-center col-md-6 col-lg-6">
                <span class="quick_fuel_banner_header">{{$t('text.sendVoucher.sendVoucher')}}</span>
              </div>
            </div>
          </div>
        </div>
        <section class="pb-5 mt-3 section_3 last__ten__transactions__row">
          <div class="row">
            <div class="col-md-12 col-lg-12 ">
              <div class="send_vouchers__row">
                <div class="index_div">
                    <p class="header_text">#</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text">{{$t('text.sendVoucher.voucherPin')}}</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text" > {{$t('text.sendVoucher.voucherAmount')}}</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text" >{{$t('text.sendVoucher.recipientPhone')}}</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text">{{$t('text.sendVoucher.message')}}</p>
                </div>
              </div>
              <div class="mt-3 send_vouchers__row" v-for="(messageDetail, index) in voucherToSendSmsDetails"
              :key="index">
                <div class="index_div">
                    <p class="header_text">{{index + 1}}</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text">{{messageDetail.pin }}</p>
                </div>
                <div class="send_vouchers__item">
                  <p class="header_text">{{  messageDetail.amount }}</p>
                </div>
                <div class="send_vouchers__item">
                   <h6>{{messageDetail.recipient}}</h6>
                </div>
                <div class="send_vouchers__item">
                   <div class="input__block input_width_shrink" ref="balance_to_input_div">
                      <input
                        type="text"
                        placeholder="Extra Message"
                        class="form-control input_full_width"
                        
                        v-model="messageDetail.extraMessage"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 text-left">
             <button
              @click="sendSms(voucherToSendSmsDetails)"
              class="save__btn record_expense_btn"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled ? { cursor: 'not-allowed' } : { cursor: 'pointer' }
              ]"
            >
              {{$t('text.sendVoucher.sendSms')}}<span></span>
              <img
                src="@/assets/img/git_loader.gif"
                style="display:none"
                width="35px"
                class="ml-3 loader"
              />
            </button>
          </div>
        </section>
           
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import voucherbackgroundUrl from "@/assets/img/roll.svg";
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Send Voucher:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout
  },
  data() {
    return {
      backgroundUrl,
      voucherbackgroundUrl,
      mode: this.$route.query.mode,
      voucherToSendSmsDetails: null,
      isButtonDisabled: false,
      routeName: null
    };
  },
  //  beforeRouteEnter(to, from, next) {
  //     // next((vm) => {
  //     //     vm.from = from;
  //     //     if(from.name === 'vehicle'){
  //     //       this.routeName = from.name
  //     //     }
  //     // });
  // },
  created() {
    if (
      localStorage.getItem("voucherToSendSmsDetails") !== null &&
      localStorage.getItem("voucherToSendSmsDetails") !== "null"
    ) {
      this.getvoucherToSendSmsDetails();
    } else {
    //   window.location.reload();
    }
  },
  methods: {
    getvoucherToSendSmsDetails() {
      let newDetails = JSON.parse(localStorage.getItem("voucherToSendSmsDetails"));
      let newvoucherToSendSmsDetails = [...newDetails];
      (newvoucherToSendSmsDetails.recipient = ""), (newvoucherToSendSmsDetails.extraMessage = "");
      this.voucherToSendSmsDetails = JSON.parse(localStorage.getItem("voucherToSendSmsDetails"));
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
     validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
   
    validatePhoneNumber() {

    },
    sendSms(voucher) {
      // voucher.forEach(el => {
      //   el.amount = "'" + el.amount + "'";
      // });
      let desc = ''
      let exit = false
      voucher.forEach(v => {
          let recp = new String(v.recipient);
          if (!v.extraMessage) {
              exit = true
              desc = 'extraMessageEmpty'
          }
          if (!v.recipient) {
              exit = true
              desc = 'recipientEmpty'
          }else {
            if (recp.length < 10 || recp.length > 13) {
              exit = true
              desc = 'invalidRecp'
            }
          }
      })
      if (exit) {
          this.$toast.open({
              message: desc === 'extraMessageEmpty' ? this.$t('text.sendVoucher.messageError') : desc === 'invalidRecp' ?  this.$t('text.sendVoucher.shortNo') : this.$t('text.sendVoucher.phoneNoBlank'),
              type: 'error',
              duration: 5000
          });
          return
      }
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Voucher/SmsVoucher`,
          voucher,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t('text.sendVoucher.successfullySent'),
            type: "success",
            duration: 20000
          });
          if(this.voucherToSendSmsDetails[0].source === 'vehicle'){
            this.$router.push({ name: voucher[0].source });
          }else if(voucher[0].source === 'driver') {
            this.$router.push({ name: 'drivers' });
          }
          
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch(error => {
          this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 20000
            });
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    }
  }
};
</script>
